import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

import { QuestionNavigationFrame } from '../../questions/types'

import style from './style.module.scss'

export interface INavigationPanelScreenNumberProps {
  screenNumber: number
  navigationFrame: QuestionNavigationFrame
}

const NavigationPanelScreenNumber = React.memo<INavigationPanelScreenNumberProps>(
  ({ screenNumber, navigationFrame }) => {
    const { t } = useInterfaceLocale()

    return (
      <span className={style.NavigationPanelContentScreenNumber} data-testid="SW-ScreenNumber">
        {t('navigation', 'screenNumber', 'label')}
        {screenNumber}
        {Array.isArray(navigationFrame) ? (
          <>
            {' '}
            ({navigationFrame[0] || '*'}/{navigationFrame[1] || '*'})
          </>
        ) : null}
      </span>
    )
  },
  (prevProps, nextProps) =>
    prevProps.screenNumber === nextProps.screenNumber && prevProps.navigationFrame === nextProps.navigationFrame
)

NavigationPanelScreenNumber.displayName = 'NavigationPanelScreenNumber'

export default NavigationPanelScreenNumber
